import ReactMarkdown from 'react-markdown';
import cn from 'classnames';
import styles from 'components/Tooltip/Tooltip.scss';

export const Tooltip = ({ children, text, className, position = 'bottom' }) => {
  return (
    <div className={cn(styles.tooltip, className, styles[position])}>
      <ReactMarkdown>{children || text}</ReactMarkdown>
    </div>
  );
};
